import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { BaseComponent } from '@macs-frontend/core';
import { makeSelectable, SelectSubscribe } from '@macs-frontend/decorators';
import { defaultUserPermissions, getUserPermissions } from '@macs-frontend/reducers/meta';
import { Store } from '@ngrx/store';

@Component({
  selector: 'md-details-header',
  templateUrl: './details-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailsHeaderComponent extends BaseComponent {
  // @ts-expect-error
  @Input() name: string;
  // @ts-expect-error
  @Input() title: string;
  @Input() labelText?: string;
  @Input() labelClasses = 'label_blue';
  // @ts-expect-error
  @Input() actionsList: string[];
  // @ts-expect-error
  @Input() logo: string;
  // @ts-expect-error
  @Input() uuid: UUID;
  // @ts-expect-error
  @Input() disableEditButton: boolean;
  @Output()
  editEntity: EventEmitter<void> = new EventEmitter<void>();
  @Output() actionCall: EventEmitter<string> = new EventEmitter<string>();
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() close: EventEmitter<void> = new EventEmitter<void>();

  @SelectSubscribe(getUserPermissions)
  userPermissions = defaultUserPermissions;

  constructor(readonly cdr: ChangeDetectorRef, readonly store$: Store<any>) {
    super();
    makeSelectable(this, { cdr, store$ });
  }

  onActionCall(action: string) {
    this.actionCall.emit(action);
  }

  onEditEntity() {
    this.editEntity.emit();
  }

  onClose() {
    this.close.emit();
  }
}
